module.exports = __webpack_public_path__ + "media/images/flags/MA-7241b4184504e3d4e49dc8b8166011ce.svg";